import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-navebar',
  templateUrl: './navebar.component.html',
  styleUrls: ['./navebar.component.scss']
})
export class NavebarComponent implements OnInit {
drawer: any;

  constructor() { }

  ngOnInit(): void {
  }

}
